import React from 'react';
import { ButtonProps } from '@mui/material';
import { MainButtonComponent } from './MainButtonStyled';

const MainButton: React.FC<ButtonProps> = (props) => <MainButtonComponent {...props} />;

export default MainButton;
